import useTools from "@/use/Tools.js";

export default function useSharedAlarm() {

  const {$i18n} = useTools();

  const alarmPeriodicity = [
    {id: 'only_once', name: $i18n.t('alarm.ONLY_ONCE')},
    // {id: 'everyDay', name: $i18n.t('alarm.EVERY_DAY')},
    {id: 'daily', name: $i18n.t('alarm.DAILY')},
    {id: 'weekly', name: $i18n.t('alarm.WEEKLY')},
    {id: 'monthly', name: $i18n.t('alarm.MONTHLY')},
    {id: 'halfYearly', name: $i18n.t('alarm.HALF_YEARLY')},
    {id: 'yearly', name: $i18n.t('alarm.YEARLY')},
  ];

  const alarmReceiverTypes = [
    {id: 'SPECIFIC', name: $i18n.t('alarm.SPECIFIC')},
    {id: 'RESPONSIBLE', name: $i18n.t('alarm.RESPONSIBLE')},
    {id: 'SERVICE', name: $i18n.t('alarm.SERVICE')},
  ];

  const sendingMethods = [
    {id: 'email', name: "Email"},
    {id: 'sms', name: "SMS"},
  ];

  const days = [
    {id: 'SATURDAY', name: $i18n.t('alarm.SATURDAY')},
    {id: 'SUNDAY', name: $i18n.t('alarm.SUNDAY')},
    {id: 'MONDAY', name: $i18n.t('alarm.MONDAY')},
    {id: 'TUESDAY', name: $i18n.t('alarm.TUESDAY')},
    {id: 'WEDNESDAY', name: $i18n.t('alarm.WEDNESDAY')},
    {id: 'THURSDAY', name: $i18n.t('alarm.THURSDAY')},
    {id: 'FRIDAY', name: $i18n.t('alarm.FRIDAY')},
  ];

  const months = [
    {id: 'JANUARY', name: $i18n.t('alarm.JANUARY')},
    {id: 'FEBRUARY', name: $i18n.t('alarm.FEBRUARY')},
    {id: 'MARCH', name: $i18n.t('alarm.MARCH')},
    {id: 'APRIL', name: $i18n.t('alarm.APRIL')},
    {id: 'MAY', name: $i18n.t('alarm.MAY')},
    {id: 'JUNE', name: $i18n.t('alarm.JUNE')},
    {id: 'JULY', name: $i18n.t('alarm.JULY')},
    {id: 'AUGUST', name: $i18n.t('alarm.AUGUST')},
    {id: 'SEPTEMBER', name: $i18n.t('alarm.SEPTEMBER')},
    {id: 'OCTOBER', name: $i18n.t('alarm.OCTOBER')},
    {id: 'NOVEMBER', name: $i18n.t('alarm.NOVEMBER')},
    {id: 'DECEMBER', name: $i18n.t('alarm.DECEMBER')},
  ];

  const halfYearlyMonths = [
    {id: 1, name: $i18n.t('alarm.JANUARY_JULY')},
    {id: 2, name: $i18n.t('alarm.FEBRUARY_AUGUST')},
    {id: 3, name: $i18n.t('alarm.MARCH_SEPTEMBER')},
    {id: 4, name: $i18n.t('alarm.APRIL_OCTOBER')},
    {id: 5, name: $i18n.t('alarm.MAY_NOVEMBER')},
    {id: 6, name: $i18n.t('alarm.JUNE_DECEMBER')},
  ];

  const monthNumberDays = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31];

  return {
    alarmPeriodicity,
    alarmReceiverTypes,
    sendingMethods,
    days,
    months,
    halfYearlyMonths,
    monthNumberDays,
  }
}